import { AsarDatePicker, AsarFormikInput } from "@/components/asarInput";
import { AsarFormikSelect } from "@/components/asarSelect";
import { Loader } from "@/components/loader";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useMemo, useState } from "react";
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import { toast } from "react-toastify";
import { addPatientToRegion2, putAddPatient } from "../../../../api/area";
import { updatePatient } from "../../../../api/group";
import FemaleIcon from "../../../../assets/SVG/femaleIcon";
import MaleIcon from "../../../../assets/SVG/maleIcon";
import * as Yup from "yup";

export default function FormReception({
  mode,
  areaId,
  ageType,
  DATA,
  handleClose,
  nationalId,
  setLevelPop,
  setSelectedLevel,
  onEdit,
  onAdd,
}) {
  const [initData, setInitData] = useState(undefined);

  const insuranceOptions = useMemo(() => {
    return [
      { label: "تکمیلی", id: "TAKMIL" },
      { label: "نیروهای مسلح", id: "MILITARY" },
      { label: "تامین اجتماعی", id: "TAMIN" },
      { label: "سلامت", id: "SALAMAT" },
      { label: "ندارد", id: "NONE" },
    ];
  }, []);

  useEffect(() => {
    if (DATA) {
      setInitData({
        ...DATA,
        birthDate: DATA.birthDate ? DATA.birthDate.split(" - ")[0] : "",
      });
      return;
    }

    setInitData({
      name: "",
      fatherName: "",
      sex: "MALE",
      birthDate: "",
      phone: "",
      identifier: nationalId ?? "",
      identifierType: mode === "irani" ? "NATIONAL_CODE" : "SRG",
      insurance: "TAMIN",
      ageType: ageType,
      job: ageType === "ADULT" ? "" : undefined,
    });
  }, [mode, ageType, nationalId, DATA]);

  const isDateValid = (date) => {
    const strings = date?.split("/");
    if (strings.length != 3) return false;
    const numbers = strings.map(Number);
    const [year, month, day] = numbers;

    if (numbers.some((number) => isNaN(number))) {
      return false;
    }

    if (month > 12 || month < 0) return false;
    if (day < 0 || day > 31) return false;
    if (year < 1200 || year > 1500) return false;
    if (strings.some((val) => val.startsWith("00"))) return false;
    return true;
  };

  if (initData === undefined) return <></>;

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("نام الزامی است")
      .min(2, "نام باید حداقل 2 کاراکتر باشد")
      .max(255, "نام باید حداکثر 255 کاراکتر باشد"),
    fatherName: Yup.string()
      .required("نام پدر الزامی است")
      .min(2, "نام پدر باید حداقل 2 کاراکتر باشد")
      .max(255, "نام پدر باید حداکثر 255 کاراکتر باشد"),
    birthDate: Yup.mixed().required("تاریخ تولد الزامی است"),
    phone: Yup.string()
      .required("شماره تلفن الزامی است")
      .matches(/^09\d{9}$/, "شماره تلفن باید با 09 شروع شود و 11 رقم باشد"),
    identifier: Yup.string()
      .required("کدملی/کد اتباع الزامی است")
      .matches(/^\d{10}$/, "کدملی/کد اتباع باید 10 رقم باشد"),
  });

  return (
    <Formik
      initialValues={initData}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      validateOnMount={false}
      onSubmit={async (values, actions) => {
        if (values.job === "") values.job = undefined;
        if (DATA?.id) {
          if (values && areaId) {
            if (!(values.birthDate instanceof DateObject)) {
              if (!isDateValid(values.birthDate)) {
                toast.error("تاریخ معتبر نمی باشد");
                actions.setSubmitting(false);
                return;
              }
              values.birthDate = new DateObject({
                date: values.birthDate,
                format: "YYYY/MM/DD",
                calendar: persian,
              });
            }

            updatePatient(DATA.id, areaId, values)
              .then(() => {
                addPatientToRegion2(areaId, values?.id)
                  .then((res) => {
                    setLevelPop(0);
                    setInitData({
                      name: "",
                      fatherName: "",
                      sex: "MALE",
                      birthDate: "",
                      phone: "",
                      identifier: "",
                      identifierType: "NATIONAL_CODE",
                      insurance: "TAMIN",
                      ageType: ageType,
                    });
                    setSelectedLevel();
                    handleClose();
                    if (onEdit)
                      onEdit({
                        ...values,
                        birthDate: values.birthDate.toString(),
                      });

                    onAdd(res);
                  })
                  .catch(() => {})
                  .finally(() => actions.setSubmitting(false));
              })
              .catch(() => {})
              .finally(() => actions.setSubmitting(false));
          }
        } else {
          if (values && areaId) {
            if (DATA) {
              addPatientToRegion2(areaId, values?.id)
                .then((res) => {
                  setLevelPop(0);
                  setInitData({
                    name: "",
                    fatherName: "",
                    sex: "MALE",
                    birthDate: "",
                    phone: "",
                    identifier: "",
                    identifierType: "NATIONAL_CODE",
                    insurance: "TAMIN",
                    ageType: ageType,
                  });
                  setSelectedLevel();
                  onAdd(res);
                  handleClose();
                })
                .catch(() => {})
                .finally(() => actions.setSubmitting(false));
            } else {
              if (!(values.birthDate instanceof DateObject)) {
                if (!isDateValid(values.birthDate)) {
                  toast.error("تاریخ معتبر نمی باشد");
                  actions.setSubmitting(false);
                  return;
                }
                values.birthDate = new DateObject({
                  date: values.birthDate,
                  format: "YYYY/MM/DD",
                  calendar: persian,
                });
              }

              putAddPatient(areaId, values)
                .then((res) => {
                  setLevelPop(0);
                  setInitData({
                    name: "",
                    fatherName: "",
                    sex: "MALE",
                    birthDate: "",
                    phone: "",
                    identifier: "",
                    identifierType: "NATIONAL_CODE",
                    insurance: "TAMIN",
                    ageType: ageType,
                  });
                  setSelectedLevel();
                  onAdd(res);
                  handleClose();
                })
                .catch(() => {})
                .finally(() => actions.setSubmitting(false));
            }
          }
        }
      }}
    >
      {({ values, setValues, isSubmitting, submitForm }) => (
        <Form>
          <Box mt="30px" gap="20px" display="flex" flexWrap={"wrap"}>
            <Grid
              display="flex"
              width="100%"
              gap="15px"
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid display={"flex"} flexDirection={"column"} gap={"5px"}>
                <Typography
                  color="text.primary"
                  sx={{
                    fontSize: "13px",
                    lineHeight: "18px",
                  }}
                >
                  {"جنسیت"}
                </Typography>
                <Box
                  display={"flex"}
                  alignContent={"center"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  border="solid 1px #d0d0d0"
                  bgcolor={"#f3f3f3"}
                  borderRadius={"8px"}
                  height="35px"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    if (values?.sex === "MALE") {
                      setValues({ ...values, sex: "FEMALE" });
                    } else {
                      setValues({ ...values, sex: "MALE" });
                    }
                  }}
                >
                  {values?.sex === "MALE" ? (
                    <MaleIcon size={"0.7"} />
                  ) : (
                    <FemaleIcon size={"0.7"} />
                  )}
                </Box>
              </Grid>
              <AsarFormikInput
                placeholder={"نام و نام خانوادگی بیمار را وارد کنید. "}
                label="نام و نام خانوادگی"
                name={"name"}
                width={"calc(100% - 50px)"}
              />
            </Grid>

            <AsarFormikInput
              placeholder={"نام پدر بیمار را وارد کنید."}
              label="نام پدر"
              name={"fatherName"}
            />
            <AsarDatePicker
              placeholder={"تاریخ تولد بیمار را انتخاب کنید."}
              label="تاریخ تولد"
              name={"birthDate"}
            />
            <AsarFormikInput
              placeholder={"شماره تلفن همراه والدین/ثابت بیمار را وارد کنید."}
              label={ageType === "ADULT" ? "شماره تلفن" : "شماره تلفن والدین"}
              name={"phone"}
              maxLength={11}
              inputMode="numeric"
            />
            <AsarFormikInput
              placeholder={
                mode === "irani"
                  ? "کد ملی بیمار را به صورت کامل وارد کنید."
                  : "کد اتباع بیمار را به صورت کامل وارد کنید."
              }
              label={mode === "irani" ? "کد ملی" : "کد اتباع"}
              name={"identifier"}
              maxLength={10}
              inputMode="numeric"
            />

            <AsarFormikSelect
              placeholder={"انتخاب کنید"}
              label="نوع بیمه"
              data={insuranceOptions}
              name={"insurance"}
            />

            {ageType === "ADULT" && (
              <AsarFormikInput
                placeholder={"شغل بیمار را به صورت کامل وارد کنید."}
                label="شغل"
                name={"job"}
              />
            )}
            {!isSubmitting && (
              <Grid
                display={"flex"}
                flexDirection={"row"}
                gap={"10px"}
                width={"100%"}
              >
                <Button
                  variant="contained"
                  sx={{ width: "calc(50% - 5px)" }}
                  onClick={submitForm}
                >
                  {DATA?.id ? "صدور نوبت مجدد" : "ایجاد بیمار"}
                </Button>
                <Button
                  sx={{ width: "calc(50% - 5px)" }}
                  variant="outlined"
                  color="error"
                  onClick={handleClose}
                >
                  انصراف
                </Button>
              </Grid>
            )}
            {isSubmitting && <Loader />}
          </Box>
        </Form>
      )}
    </Formik>
  );
}
